import { CurrencyService } from '@lemon/core/service/currency.service'
import { VeroilmoitusLomakeTunniste } from 'app/_jaettu-lemonator/model/kirjanpito'
import { RepeatingMetadata } from 'app/_jaettu-lemonator/service/veroilmoitus/base-specialized-calculation.service'
import { Korvausparametrit, VeroilmoitusTranslationService } from '../../../_jaettu-lemonator/service/veroilmoitus/veroilmoitus-translation.service'
import { VeroilmoituksenMuokkaustiedot } from '../veroilmoitus.component'

export abstract class KirjanpitoVeroilmoitusBaseCommonComponent {
  constructor(
    protected _currencyService: CurrencyService,
    protected _veroilmoitusTranslationService: VeroilmoitusTranslationService,
  ) {}

  protected _localizeNumeroHeader(numero: string, lomake: VeroilmoitusLomakeTunniste, veroilmoitus: VeroilmoituksenMuokkaustiedot, parametrit?: Korvausparametrit) {
    if (!veroilmoitus?.perustiedot?.asiakas) {
      return ''
    }
    const nro = this._annaLomakeTunniste(lomake, numero)
    const yritysmuoto = veroilmoitus.perustiedot.asiakas.yritysmuoto
    const vuosi = veroilmoitus.perustiedot.tilikausi.loppuu.year
    return this._veroilmoitusTranslationService.localizeSilent(nro + '-header', yritysmuoto, vuosi, veroilmoitus.kieli, parametrit)
  }

  protected _localizeNumero(numero: string, lomake: VeroilmoitusLomakeTunniste, veroilmoitus: VeroilmoituksenMuokkaustiedot, parametrit?: Korvausparametrit) {
    if (!veroilmoitus?.perustiedot?.asiakas) {
      return ''
    }
    const nro = this._annaLomakeTunniste(lomake, numero)
    const yritysmuoto = veroilmoitus.perustiedot.asiakas.yritysmuoto
    const vuosi = veroilmoitus.perustiedot.tilikausi.loppuu.year
    return this._veroilmoitusTranslationService.localize(nro, yritysmuoto, vuosi, veroilmoitus.kieli, parametrit)
  }

  protected _localizeNumeroHelp(numero: string, lomake: VeroilmoitusLomakeTunniste, veroilmoitus: VeroilmoituksenMuokkaustiedot, parametrit?: Korvausparametrit) {
    if (!veroilmoitus?.perustiedot?.asiakas) {
      return ''
    }
    const nro = this._annaLomakeTunniste(lomake, numero)
    const yritysmuoto = veroilmoitus.perustiedot.asiakas.yritysmuoto
    const vuosi = veroilmoitus.perustiedot.tilikausi.loppuu.year
    return this._veroilmoitusTranslationService.localizeSilent(nro + '-help', yritysmuoto, vuosi, veroilmoitus.kieli, parametrit)
  }

  protected _annaStringEhdotus(numero: string, lomake: VeroilmoitusLomakeTunniste, veroilmoitus: VeroilmoituksenMuokkaustiedot): string | null {
    const nro = this._annaLomakeTunniste(lomake, numero)
    const arvo = veroilmoitus?.oletukset[nro || 'asfd'] ?? null
    if (arvo !== null && arvo !== undefined) {
      return arvo + ''
    }
    return null
  }

  protected _annaEhdotus(numero: string, lomake: VeroilmoitusLomakeTunniste, veroilmoitus: VeroilmoituksenMuokkaustiedot): string | number | null {
    const nro = this._annaLomakeTunniste(lomake, numero)
    const oletukset = veroilmoitus?.oletukset
    if (oletukset) {
      return oletukset[nro || 'asfd'] ?? null
    }
    return null
  }

  protected annaTiedonTunniste(numero: string, lomake: VeroilmoitusLomakeTunniste, repeatingMetadata?: RepeatingMetadata) {
    if (repeatingMetadata) {
      return repeatingMetadata.groupdIdentifier + '_' + repeatingMetadata.order + '_' + numero
    }
    if (lomake) {
      return this._annaLomakeTunniste(lomake, numero)
    }
    return numero
  }

  protected _annaNumeroEhdotus(numero: string, lomake: VeroilmoitusLomakeTunniste, veroilmoitus: VeroilmoituksenMuokkaustiedot): number {
    const rawValue = this._annaEhdotus(numero, lomake, veroilmoitus)
    if (this._currencyService.onkoNumero(rawValue)) {
      return rawValue as number
    }
    return this._currencyService.muutaMerkkijonoNumeroksi(rawValue as string, 2)
  }

  protected _annaLomakeTunniste(lomake: VeroilmoitusLomakeTunniste, numero: string): string {
    return lomake ? lomake + '_' + numero : numero
  }
}
